import { Component, OnInit } from '@angular/core';
import { RandomuserService } from '../services/randomuser.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  randomUser: any = [];

  constructor( private randomuserService: RandomuserService ) { }

  ngOnInit(): void {
    
  }

  newRandomUser(){

    this.randomuserService.getUser()
        .subscribe( (resp: any) => { 
          // console.log(resp);
          this.randomUser = resp;          
        });
  }



}
